import * as React from 'react';
import { lazyLoad } from '../../../utils/loadable';

export const MalloyQueryPage = props => {
  return lazyLoad(
    () => import('./index'),
    module => module.MalloyQueryPage,
    { fallback: <div></div> },
  )(props);
};
